import { Factory } from "./Factory";
import Menu from "../EditorComponents/Gallery/Menu";

export class GalleryFactory extends Factory {
  constructor(qty = 1) {
    super();
    this.qty = qty;
  }

  object() {
    return {
      id: this.id("gallery"),
      containerId: this.id("container"),
      slug: "editor-gallery",
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: "color",
        tablet: "color",
        desktop: "color"
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      name: "Gallery"
    };
  }

  galleryTypes() {
    return [
      { value: "grid", text: "Grid" },
      //{ value: "masonry", text: "Masonry" },
      { value: "slider", text: "Slider" }
    ];
  }

  numberImages() {
    return [
      { value: 2, text: "2" },
      { value: 3, text: "3" },
      { value: 4, text: "4" },
      { value: 5, text: "5" }
    ];
  }

  properties() {
    return {
      content: [
        { key: "source-content", component: "ContentMediaSource" },
        { key: "gallery-type", component: "ContentSelect", text: "Type", property: "type", items: this.galleryTypes() },
        {
          key: "number-images",
          component: "ContentSelect",
          text: "Number",
          property: "numberImages",
          items: this.numberImages()
        }
      ],
      containerStyles: [
        { key: "padding", component: "PaddingProperty", class: "containerClasses" },
      ],
      styles: [
        { key: "padding", component: "PaddingProperty" },
        { key: "shadow", component: "ShadowProperty", class: "contentClasses" },
        { key: "rounded", component: "RoundedProperty", class: "contentClasses" }
      ],
      sliderStyles: [
        { key: "gallery-height", component: "CustomHeightProperty", styles: "sliderStyles" },
      ],
      buttonsStyles: [
        { key: "background", component: "BackgroundProperty", styles: "buttonsStyles", only: ["color"] },
        { key: "rounded", component: "RoundedProperty", class: "buttonsClasses" },
        { key: "icon-color", component: "TextColorProperty", styles: "buttonsStyles" }
      ],
      dotsStyles: [
        { key: "carousel-dots", component: "CarouselDotStyleProperty", class:"dotsClasses"},
        { key: "border", component: "BorderProperty", class: "dotsClasses", styles:"dotsStyles", only: ["color"]},
        { key: "background", component: "BackgroundProperty", styles:"activeDotsStyles", only: ["color"]},
      ],
      advanced: [
        {key: "element-id", component: "ElementId" },
        {key: "custom-classes", component: "CustomClasses" },
        {key: "custom-styles", component: "CustomStyles" },
      ],
      menu: Menu
    };
  }
}
